import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { useDetailParam } from "../utils/detailParam";
import { fetchProductNumberById } from "../api/productNumberService";
export var useProductNumberActions = function () {
    var ky = useOkapiKy();
    var _a = useDetailParam(), detailId = _a.detailId, updateDetailParam = _a.updateDetailParam;
    var selectedProductNumber = useQuery(["productNumber", detailId], function () { return fetchProductNumberById(ky, detailId); }, {
        enabled: !!detailId,
    }).data;
    var handleRowClick = function (item) {
        updateDetailParam(item.id);
    };
    var handleCloseDetail = function () {
        updateDetailParam(null);
    };
    return {
        selectedProductNumber: selectedProductNumber,
        handleRowClick: handleRowClick,
        handleCloseDetail: handleCloseDetail,
    };
};
